import { get } from "api/get";
import { put } from "api/put";
import { appendStatus } from "state/status/actions";
import _ from 'lodash';


export const GET_ROI_VALUES_REQUEST = "roi-values/get/request";
export const GET_ROI_VALUES_SUCCESS = "roi-values/get/success";
export const GET_ROI_VALUES_FAILURE = "roi-values/get/failure";

export const SAVE_ROI_VALUES_REQUEST = 'roi-values/save/request';
export const SAVE_ROI_VALUES_SUCCESS = "roi-values/save/success";
export const SAVE_ROI_VALUES_FAILURE = "roi-values/save/failure";

export function getROIValues() {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_ROI_VALUES_REQUEST,
        payload: null,
      });

      const req = await get("global-settings/roi-variables");
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: GET_ROI_VALUES_SUCCESS,
        payload: data,
      });
      
    } catch (error) {
      dispatch({
        type: GET_ROI_VALUES_FAILURE,
        payload: null,
      });

      dispatch(appendStatus('An unknown error occurre. Please try again.', 'error'));
    }
  };
}

export function saveROIValues(vars) {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_ROI_VALUES_REQUEST,
        payload: null,
      });

      // Convert all values to float
      for ( const [varGroupKey, varGroupValue] of Object.entries(vars) ) {
        for ( const [valKey, val] of Object.entries(varGroupValue) ) {

          if (varGroupKey === 'networkFeeFreightMovement' || varGroupKey === 'percentageRatesByTier' || varGroupKey === 'tierVar' ) {
            for ( const [ freightKey, freightVal ] of Object.entries(val) ) {
              vars[varGroupKey][valKey][freightKey] = parseFloat(freightVal);
            }

          } else {
            vars[varGroupKey][valKey] = parseFloat(val);
          }
        }
      }

      const req = await put("global-settings/roi-variables", {
        payload: vars
      });
      const data = _.get(req, "data.payload", []);

      dispatch({
        type: SAVE_ROI_VALUES_SUCCESS,
        payload: data,
      });

      dispatch(appendStatus('Values saved successfully.', 'info'));

    } catch (error) {
      dispatch({
        type: SAVE_ROI_VALUES_FAILURE,
        payload: null,
      });

      dispatch(appendStatus("An unknown error occurre. Please try again.", "error"));
    }
  };
}

